<template>
  <div class="filters">
    <v-row class="align-center">
      <v-col cols="3">
        <h4>Filter By: </h4>
      </v-col>
      <v-col cols="9">
        <v-select hide-details dense outlined
        class="input-text-size" label="Select Filter" :items="filterList" item-value="value"
        v-model="tabsInit" @change="onChangeFilterVal">
        </v-select>
      </v-col>
    </v-row>
    <!-- tax -->
    <div class="list-btns-filter" v-if="tabsInit === 1">
      <v-row class="">
        <v-col cols="6" class="">
                    <CommonDropDowns class="mt-n3 mr-1" :isItTaxYearWithoutAllYears=true
                    taxYearLabelOverride="From Tax Year" taxYearNameOverride="taxYearFrom"
            @change="dataFromCommonDropDowns"
            :addTaxYearEmpty=true />
          <CommonDropDowns class="mt-n3 mr-1" :isItTaxYearWithoutAllYears=true
                    taxYearLabelOverride="To Tax Year" taxYearNameOverride="taxYearTo"
            @change="dataFromCommonDropDowns"
            :addTaxYearEmpty=true />
        </v-col>
        <v-col cols="6">
          <v-text-field class="input-text-size my-2"
          outlined small hide-details dense label="From Tax ID"
          v-model.number="criteriaState.fromTaxId" @blur="searchByCriteria">
          </v-text-field>
          <v-text-field outlined small hide-details dense label="To Tax ID"
          v-model.number="criteriaState.toTaxId" @blur="searchByCriteria">
          </v-text-field>
        </v-col>
      </v-row>
    </div>
    <!-- mtg -->
    <div class="list-btns-filter" v-if="tabsInit === 2">
      <v-row>
        <v-col><v-text-field class="input-text-size my-2"
           outlined small hide-details dense label="From Mtg Code"
           v-model="criteriaState.incfromMtgCode" @blur="searchByCriteria">
          </v-text-field>

          <v-text-field outlined small hide-details dense label="To Mtg Code"
          v-model="criteriaState.inctoMtgCode" @blur="searchByCriteria">
          </v-text-field></v-col>
        <v-col> <v-text-field class="input-text-size my-2"
          outlined small hide-details dense label="From Name"
          v-model="criteriaState.ownerNameFrom" @blur="searchByCriteria">
          </v-text-field>
          <v-text-field outlined small hide-details dense label="To Name"
          v-model="criteriaState.ownerNameTo" @blur="searchByCriteria">
          </v-text-field></v-col>
      </v-row>
    </div>
    <!-- owner name -->
    <div class="list-btns-filter" v-if="tabsInit === 3">
      <v-row>
        <v-col>
          <v-text-field outlined small hide-details dense label="From Name"
          class="input-text-size mt-2"
          v-model="criteriaState.ownerNameFrom" @blur="searchByCriteria">
          </v-text-field>
        </v-col>
        <v-col>
          <v-text-field outlined small hide-details dense label="To Name"
          class="input-text-size mt-2"
          v-model="criteriaState.ownerNameTo" @blur="searchByCriteria">

          </v-text-field></v-col>
      </v-row>
    </div>
    <!-- other -->
    <div class="list-btns-filter" v-if="tabsInit === 4">
      <v-row>
        <v-col>
          <v-text-field outlined small hide-details dense label="From Email Address"
          class="input-text-size mt-2">
          </v-text-field>
        </v-col>
        <v-col>
          <v-text-field outlined small hide-details dense label="To Email Address"
          class="input-text-size mt-2">

          </v-text-field></v-col>
      </v-row>
    </div>
    <!-- parcel id -->
    <div class="list-btns-filter" v-if="tabsInit === 5">
      <v-row>
        <v-col>
          <v-text-field outlined small hide-details dense label="From Parcel ID"
          class="input-text-size mt-2"
          v-model="criteriaState.parcelIdFrom" @blur="searchByCriteria">
          </v-text-field>
        </v-col>
        <v-col>
          <v-text-field outlined small hide-details dense label="To Parcel ID"
          class="input-text-size mt-2"
          v-model="criteriaState.parcelIdTo" @blur="searchByCriteria">

          </v-text-field></v-col>
      </v-row>
    </div>
    <div class="list-btns-filter" v-if="tabsInit === 6"></div>
  </div>
</template>

<script>
import {
  mapGetters, mapMutations,
} from 'vuex';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import { getWorkstationNumber } from '../../../util/workstation-util';

export default {
  name: 'browsetrWorkFileFilters',
  data() {
    return {
      filterList: [
        {
          text: 'Tax ID',
          value: 1,
        },
        {
          text: 'Mortgage Code & Name',
          value: 2,

        },
        {
          text: 'Owner Name',
          value: 3,

        },
        {
          text: 'Email Address',
          value: 4,

        },
        {
          text: 'Parcel ID',
          value: 5,
        },
        {
          text: 'Selected',
          value: 6,
        },
      ],
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
    handletrWorkFileRecords: {
      type: Function,
      default: () => ({}),
    },
  },
  components: {
    CommonDropDowns,
  },
  async created() {
    this.wkstNumber = getWorkstationNumber();
    this.tabsInit = 0;
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'items',
      'item',
      'selectedTab',
    ]),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    tabsInit: {
      get() {
        return this.selectedTab(this.baseCrudKey);
      },
      set(value) {
        this.setSelectedTab([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
      'setSelectedTab',
    ]),
    onChangeFilterVal() {
      // const previousFilterIndex = this.criteriaState.selFilterIndex;

      // if (previousFilterIndex !== val) {
      //   switch (previousFilterIndex) {
      //     case 1:
      //       this.criteriaState.fromTaxId = null;
      //       this.criteriaState.toTaxId = null;
      //       this.criteriaState.taxYearFrom = null;
      //       this.criteriaState.taxYearTo = null;
      //       break;
      //     case 2:
      //       this.criteriaState.incfromMtgCode = null;
      //       this.criteriaState.inctoMtgCode = null;
      //       this.criteriaState.ownerNameFrom = null;
      //       this.criteriaState.ownerNameTo = null;
      //       break;
      //     case 3:
      //       this.criteriaState.ownerNameFrom = null;
      //       this.criteriaState.ownerNameTo = null;
      //       break;
      //     case 4:
      //       // No email fields currently bound to criteriaState
      //       break;
      //     case 5:
      //       this.criteriaState.parcelIdFrom = null;
      //       this.criteriaState.parcelIdTo = null;
      //       break;
      //     case 6:
      //       this.criteriaState.ids = null;
      //       break;
      //     default:
      //       break;
      //   }
      // }

      // reset all the fields to null
      this.criteriaState.fromTaxId = null;
      this.criteriaState.toTaxId = null;
      this.criteriaState.taxYearFrom = null;
      this.criteriaState.taxYearTo = null;
      this.criteriaState.incfromMtgCode = null;
      this.criteriaState.inctoMtgCode = null;
      this.criteriaState.ownerNameFrom = null;
      this.criteriaState.ownerNameTo = null;
      this.criteriaState.ownerNameFrom = null;
      this.criteriaState.ownerNameTo = null;
      this.criteriaState.parcelIdFrom = null;
      this.criteriaState.parcelIdTo = null;
      this.criteriaState.ids = null;

      // calling the searchByCriteria to update the items
      this.searchByCriteria();
    },
    dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      this.searchByCriteria();
    },
    searchByCriteria() {
      this.handletrWorkFileRecords();
    },
  },
};
</script>

<style scoped>
.filters {
  margin-bottom: 0.5rem;
  border: 1px solid lightgray;
  padding: 0.5rem;

}

.list-btns-filter {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
